class Context
{
    init(_options)
    {
        // Options
        this.time = _options.time
        this.sizes = _options.sizes
        this.renderer = _options.renderer
        this.debug = _options.debug
        this.config = _options.config

    }
}

const ContextInstance = new Context();

export default ContextInstance;
